import colors from "shared/styles/colors";
import { device } from "shared/styles/helpers";
import { bpmnPaletteBackgroundColor, ThemeType } from "shared/styles/theme";
import styled, { css } from "styled-components";
import theme from "styled-theming";

const colorPaletterFilter = theme("mode", {
    [ThemeType.light]: "none",
    [ThemeType.dark]: "invert(97%) sepia(0%) saturate(7481%) hue-rotate(75deg) brightness(105%) contrast(106%)"
})

const ProcessCanvasStyles = css`
    position: absolute;
    top: 90px; /* space for header + 10px */
    bottom: 50px; /* space for footer + 10px */
    left: 0;

    .Resizer {
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        opacity: .2;
        z-index: 1;
        -moz-background-clip: padding;
        -webkit-background-clip: padding;
        background-clip: padding-box;
    }
    
    .Pane {
        overflow-y: auto;
        overflow-x: hidden;
    }

    .Pane2 {
        border: 1px solid ${colors.grey_2};
        border-top-left-radius: 25px;
        margin-top: 35px;
    }

    .Resizer:hover {
        -webkit-transition: all .2s ease;
        transition: all .2s ease;
    }

    .Resizer.vertical {
        width: 11px;
        margin: 0 -5px;
        cursor: col-resize;
    }

    /* hide parameter editor resizer when panel is hidden */
    .hide-parameter-editor .Resizer.vertical{
        display: none;
    }
    .Pane.vertical.Pane1 {
        min-width: 0px;
    }

    .Resizer.vertical {
        height: 100%;
        margin: auto 0;
        margin-top: 50px;
        &:hover {
            border-right: 5px solid rgba(0, 0, 0, 0.5);
        }
    }

    .Resizer.disabled {
        cursor: not-allowed;
    }
    .Resizer.disabled:hover {
        border-color: transparent;
    }
    .bpmn-hover-tooltip {
        background-color: ${colors.grey_5};
        border: 1px solid ${colors.grey_2};
        border-radius: 15px;
        padding: 10px;
        .tooltip-inner {
            font-size: var(--small-text-font-size);
            font-family: "Gilroy-Regular", "regular-fallback";
            color: ${colors.grey_1};
        }
    }
    .bpmn-icon-color img {
        filter: ${colorPaletterFilter};
    }
`;

export const ProcessEditorCanvas = styled.div`
    ${ProcessCanvasStyles};
    right: 0;
`

export const ProcessDetailsCanvas = styled.div`
    ${ProcessCanvasStyles};
    right: 0;
`;

export const ProcessEditorHeader = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: absolute;
    width: 100%;
    z-index: 2;
    pointer-events: none;
    padding: 0px 11px 11px 0px;
    @media ${device.desktop} {
        padding: 11px;
    }
`

export const ProcessName = styled.h1``

export const HeaderNameAndContentContainer = styled.div<{ $justifySpaceBetween?: boolean }>`
    margin-left: 10px;
    display: flex;
    align-items: baseline;
    pointer-events: all;
    cursor: pointer;
    ${props => props.$justifySpaceBetween && css`
    justify-content: space-between;
    `} 
    @media ${device.desktop} {
        margin-left: 30px;
    }
`

export const ProcessVersion = styled.h3`
    margin-left: 10px;
`

export const PlaceholderText = styled.span<{ hasError?: boolean }>`
    ${props => props.hasError ? css`
        color: ${colors.warningPrimary};
        opacity: 0.75;
    ` : css`
        color: ${colors.grey_3};
    `}
`

export const CanvasCustomControls = styled.div`
    position: absolute;
    left: 10px;
    bottom: 5px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    border: 1px solid ${colors.grey_2};
    background-color: ${bpmnPaletteBackgroundColor};
    text-align: center;
    @media ${device.desktop} {
        left: 38px;
    }
    div {
        width: 100%;
        height: 100%;
        padding: 5px;
        display: flex;
    }
    i {
        font-size: 1.563rem;
    }
    hr {
        display: inline-block;
        height: 28px;
        margin: 0;
    }
`